// Mirrors descriptions on DescribedStrEnum subclasses in glynt-schemas.
// Source of truth: glynt-schemas/glynt_schemas/data/enums.py
// Update this file when the corresponding Python enum's description changes.

import { DocumentDataExclusionReasons, ParentRelationship } from './packager-types';

export const DocumentDataExclusionReasonDescriptions: Record<DocumentDataExclusionReasons, string> = {
  [DocumentDataExclusionReasons.FILE_UNUSABLE]: 'The Source File cannot be used or opened',
  [DocumentDataExclusionReasons.IMAGE_UNUSABLE]:
    'The Source File visual representation of the pages is too poor and cannot be used',
  [DocumentDataExclusionReasons.DUPLICATE]:
    'The Source File or its data is a duplicative of another file or its data',
  [DocumentDataExclusionReasons.NO_ACTIVITY]: 'The Source File did not contain any activity data',
  [DocumentDataExclusionReasons.MISSING_PAGES]:
    'The Source File did not contain all the activity data due to missing pages',
  [DocumentDataExclusionReasons.OUT_OF_SCOPE]:
    'The Source File is out of scope. This is a reviewer call if the document has nothing to do with the activity data for example',
  [DocumentDataExclusionReasons.CONCATENATED]:
    'The Source File was a concatenation of multiple files and was split, the associated data will be delivered with the child files',
  [DocumentDataExclusionReasons.TRANSLATED]:
    'The Source File was translated and re created in a new language',
  [DocumentDataExclusionReasons.ROTATED]:
    'The Source File was rotated and re creeated. The associated data will be delivered with the child file',
  [DocumentDataExclusionReasons.CANCELLED]:
    'The Source File was created by mistake and is not directly coming from the customer',
  [DocumentDataExclusionReasons.RE_INTRODUCED]:
    'The Source File re-introduced in the system for processing reasons, the associated data will be delivered with the re-introduced child file',
};

export const ParentRelationshipDescriptions: Record<ParentRelationship, string> = {
  [ParentRelationship.TRANSLATED]:
    'The Source File is a translation of the file identified by ParentFileID',
  [ParentRelationship.DUPLICATE]:
    'The Source File is a duplicate of the file identified by ParentFileID',
  [ParentRelationship.SPLIT]:
    'The Source File is a child resulting from the split of the file identified by ParentFileID',
  [ParentRelationship.REINTRODUCED]:
    'The Source File is a duplicate of the file identified by ParentFileID, re-created in the system for processing purposes',
};

const titleCase = (value: string): string =>
  value.replace(/[-_]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const formatExclusionReason = (value: DocumentDataExclusionReasons | string): string =>
  titleCase(String(value));

export const formatParentRelationship = (value: ParentRelationship | string): string =>
  titleCase(String(value));
